// Shared Notes-column renderer used by BOTH the Master Board and the Manager
// Board so their Notes behavior can never drift. Shows up to 3 clipped lines
// inside a fixed-width, height-capped cell; clicking opens the project's full
// General Project Notes history.
export function BoardNotesPreview({ row, onOpen, testId }) {
  const bodies = row.recent_note_bodies || [];
  const total = row.recent_notes_total ?? bodies.length;
  const extra = Math.max(0, total - bodies.length);

  if (!bodies.length) {
    return <span className="board-notes-empty" data-testid={testId}>—</span>;
  }

  return (
    <button
      className="board-notes-preview"
      data-testid={testId}
      onClick={onOpen}
      title={bodies.join("\n")}
      type="button"
    >
      {bodies.map((body, index) => (
        <span className="board-notes-line" key={index}>{body}</span>
      ))}
      {extra > 0 && (
        <span className="board-notes-more">+{extra} more · view history</span>
      )}
    </button>
  );
}
